import type { PromptInputContext, TemplateRepresentationValue } from '@atlassian/conversation-assistant-external-context/types';

import { useExternalContextsStore } from '../attachtment-store';

export const useConversationExternalAttachments = (key: string): {
    addExternalContext: (key: string, context: PromptInputContext[]) => void; externalContextsServiceRepresentations: {
        key: "template";
        value: TemplateRepresentationValue;
    }[];
} => {
	const [externalContexts, { addExternalContext }] = useExternalContextsStore(key);

	const externalContextsServiceRepresentations = externalContexts.map(
		(context) => context.serviceRepresentation,
	);

	return { addExternalContext, externalContextsServiceRepresentations };
};
